// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.V68YTM {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.V68YTM:hover:not(.IwJf_e) {
  background: var(--sidebar-item-hover-bg, #f5f5f5) !important;
}

.IwJf_e {
  background: var(--sidebar-item-selected-bg, #b23a00) !important;
}

.XMalAY {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  opacity: 0;
  visibility: hidden;
  transition:
    opacity 0.3s ease,
    visibility 0.3s ease;
}

.XMalAY.V0xZ97 {
  opacity: 1;
  visibility: visible;
}

.Lk9s99 {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  height: 100vh !important;
  z-index: 1000 !important;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15) !important;
  transform: translateX(-100%);
  transition:
    transform 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    visibility 0.3s ease,
    opacity 0.3s ease;
  display: flex !important;
  flex-direction: column !important;
  overflow: hidden !important;
  background: var(--sidebar-background, white) !important;
  border-right: 1px solid var(--sidebar-border, #f2f2f2) !important;
  width: var(--sidebar-width-expanded, 224px) !important;
  min-width: var(--sidebar-width-expanded, 224px) !important;
  font-family: var(--font-family-base, 'Source Sans 3', Arial, sans-serif) !important;
  visibility: hidden;
  opacity: 0;
}

.Lk9s99.V0xZ97 {
  transform: translateX(0);
  visibility: visible;
  opacity: 1;
}

.Lk9s99.JUylJP {
  transform: translateX(-100%);
}

.g9eVvt {
  border-top: 4px solid var(--sidebar-top-border-color, #d64000);
  height: 4px;
}

.HJoRqN {
  display: flex;
  flex-direction: column;
  align-self: stretch;
  gap: var(--sidebar-gap, 4px);
  padding: var(--sidebar-padding, 12px);
  flex: 1;
}

.aklxO5 {
  display: flex;
  flex-direction: column;
  align-self: stretch;
  padding: var(--sidebar-padding, 12px);
}

.svQapB {
  display: flex;
  align-items: center;
  align-self: stretch;
  border-top: 4px solid var(--sidebar-top-border-color, #d64000);
  min-height: 64px;
  box-sizing: border-box;
}

.svQapB.crg3Xs {
  gap: 0px;
  padding: 4px 8px 0px;
  justify-content: center;
}

.svQapB.m8TOKQ {
  gap: var(--sidebar-gap, 16px);
  padding: 4px var(--sidebar-padding, 16px) 0px;
  justify-content: flex-start;
}

.gvZ_C1 {
  background: none;
  border: none;
  cursor: pointer;
  padding: var(--sidebar-item-padding, 8px);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--sidebar-item-border-radius, 4px);
  transition: background-color 0.15s ease;
}

.gvZ_C1:hover {
  background: var(--sidebar-item-hover-bg, #f5f5f5);
}

/* Desktop Sidebar Styles */
.fa43HX {
  display: flex;
  flex-direction: column;
  transition: width 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.AOTUtj {
  display: flex;
  align-items: center;
  align-self: stretch;
  min-height: 64px;
  box-sizing: border-box;
  padding: var(--sidebar-padding, 12px);
  gap: var(--sidebar-padding, 16px);
}

.AOTUtj.crg3Xs {
  gap: 0px;
  padding: 4px 8px 0px;
  justify-content: center;
}

.AOTUtj.m8TOKQ {
  gap: 16px;
  padding: 4px 16px 0px;
  justify-content: flex-start;
}

.ThLNU3 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 1px 0px;
  gap: 10px;
}

.IbvAg8 {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
}

.Me12AO {
  display: flex;
  align-items: center;
  gap: var(--sidebar-gap, 16px);
  flex: 1;
  height: 21px;
}

.tXTRwf {
  display: flex;
  align-items: center;
  height: 100%;
}

.tZpZRK {
  width: 125px;
  height: 22px;
}

.NO26Zj {
  font-weight: 600;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pHfXNQ {
  display: flex;
  flex-direction: column;
  align-self: stretch;
  gap: var(--sidebar-gap, 4px);
  flex: 1;
  padding: var(--sidebar-padding, 12px);
}

.pHfXNQ.crg3Xs {
  padding: var(--sidebar-padding, 12px) 0px;
}

.pHfXNQ.m8TOKQ {
  padding: var(--sidebar-padding, 12px);
}

.y5n0am {
  display: flex;
  flex-direction: column;
  align-self: stretch;
  padding: var(--sidebar-padding, 12px);
}

.y5n0am.crg3Xs {
  padding: var(--sidebar-padding, 12px) 0px;
}

.y5n0am.m8TOKQ {
  padding: var(--sidebar-padding, 12px);
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/Sidebar.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB;;wBAEsB;AACxB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,oDAAoD;EACpD,4BAA4B;EAC5B;;;qBAGmB;EACnB,wBAAwB;EACxB,iCAAiC;EACjC,2BAA2B;EAC3B,uDAAuD;EACvD,iEAAiE;EACjE,sDAAsD;EACtD,0DAA0D;EAC1D,mFAAmF;EACnF,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8DAA8D;EAC9D,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,4BAA4B;EAC5B,qCAAqC;EACrC,OAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8DAA8D;EAC9D,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,QAAQ;EACR,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qDAAqD;EACrD,uCAAuC;AACzC;;AAEA;EACE,iDAAiD;AACnD;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,mDAAmD;EACnD,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA;EACE,QAAQ;EACR,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,4BAA4B;EAC5B,OAAO;EACP,qCAAqC;AACvC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;AACvC","sourcesContent":[".sidebar-item {\n  user-select: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n}\n\n.sidebar-item:hover:not(.sidebar-item-selected) {\n  background: var(--sidebar-item-hover-bg, #f5f5f5) !important;\n}\n\n.sidebar-item-selected {\n  background: var(--sidebar-item-selected-bg, #b23a00) !important;\n}\n\n.sidebar-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 999;\n  opacity: 0;\n  visibility: hidden;\n  transition:\n    opacity 0.3s ease,\n    visibility 0.3s ease;\n}\n\n.sidebar-overlay.active {\n  opacity: 1;\n  visibility: visible;\n}\n\n.sidebar-mobile {\n  position: fixed !important;\n  top: 0 !important;\n  left: 0 !important;\n  height: 100vh !important;\n  z-index: 1000 !important;\n  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15) !important;\n  transform: translateX(-100%);\n  transition:\n    transform 0.3s cubic-bezier(0.4, 0, 0.2, 1),\n    visibility 0.3s ease,\n    opacity 0.3s ease;\n  display: flex !important;\n  flex-direction: column !important;\n  overflow: hidden !important;\n  background: var(--sidebar-background, white) !important;\n  border-right: 1px solid var(--sidebar-border, #f2f2f2) !important;\n  width: var(--sidebar-width-expanded, 224px) !important;\n  min-width: var(--sidebar-width-expanded, 224px) !important;\n  font-family: var(--font-family-base, 'Source Sans 3', Arial, sans-serif) !important;\n  visibility: hidden;\n  opacity: 0;\n}\n\n.sidebar-mobile.active {\n  transform: translateX(0);\n  visibility: visible;\n  opacity: 1;\n}\n\n.sidebar-mobile.closing {\n  transform: translateX(-100%);\n}\n\n.sidebar-mobile-header {\n  border-top: 4px solid var(--sidebar-top-border-color, #d64000);\n  height: 4px;\n}\n\n.sidebar-mobile-content {\n  display: flex;\n  flex-direction: column;\n  align-self: stretch;\n  gap: var(--sidebar-gap, 4px);\n  padding: var(--sidebar-padding, 12px);\n  flex: 1;\n}\n\n.sidebar-mobile-support {\n  display: flex;\n  flex-direction: column;\n  align-self: stretch;\n  padding: var(--sidebar-padding, 12px);\n}\n\n.sidebar-desktop-header {\n  display: flex;\n  align-items: center;\n  align-self: stretch;\n  border-top: 4px solid var(--sidebar-top-border-color, #d64000);\n  min-height: 64px;\n  box-sizing: border-box;\n}\n\n.sidebar-desktop-header.collapsed {\n  gap: 0px;\n  padding: 4px 8px 0px;\n  justify-content: center;\n}\n\n.sidebar-desktop-header.expanded {\n  gap: var(--sidebar-gap, 16px);\n  padding: 4px var(--sidebar-padding, 16px) 0px;\n  justify-content: flex-start;\n}\n\n.sidebar-toggle-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: var(--sidebar-item-padding, 8px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--sidebar-item-border-radius, 4px);\n  transition: background-color 0.15s ease;\n}\n\n.sidebar-toggle-button:hover {\n  background: var(--sidebar-item-hover-bg, #f5f5f5);\n}\n\n/* Desktop Sidebar Styles */\n.sidebar-desktop {\n  display: flex;\n  flex-direction: column;\n  transition: width 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  overflow: hidden;\n}\n\n.sidebar-header {\n  display: flex;\n  align-items: center;\n  align-self: stretch;\n  min-height: 64px;\n  box-sizing: border-box;\n  padding: var(--sidebar-padding, 12px);\n  gap: var(--sidebar-padding, 16px);\n}\n\n.sidebar-header.collapsed {\n  gap: 0px;\n  padding: 4px 8px 0px;\n  justify-content: center;\n}\n\n.sidebar-header.expanded {\n  gap: 16px;\n  padding: 4px 16px 0px;\n  justify-content: flex-start;\n}\n\n.sidebar-collapse-button-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  padding: 1px 0px;\n  gap: 10px;\n}\n\n.sidebar-collapse-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n}\n\n.sidebar-logo-container {\n  display: flex;\n  align-items: center;\n  gap: var(--sidebar-gap, 16px);\n  flex: 1;\n  height: 21px;\n}\n\n.sidebar-logo {\n  display: flex;\n  align-items: center;\n  height: 100%;\n}\n\n.sidebar-logo-image {\n  width: 125px;\n  height: 22px;\n}\n\n.sidebar-title {\n  font-weight: 600;\n  font-size: 14px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.sidebar-content {\n  display: flex;\n  flex-direction: column;\n  align-self: stretch;\n  gap: var(--sidebar-gap, 4px);\n  flex: 1;\n  padding: var(--sidebar-padding, 12px);\n}\n\n.sidebar-content.collapsed {\n  padding: var(--sidebar-padding, 12px) 0px;\n}\n\n.sidebar-content.expanded {\n  padding: var(--sidebar-padding, 12px);\n}\n\n.sidebar-support {\n  display: flex;\n  flex-direction: column;\n  align-self: stretch;\n  padding: var(--sidebar-padding, 12px);\n}\n\n.sidebar-support.collapsed {\n  padding: var(--sidebar-padding, 12px) 0px;\n}\n\n.sidebar-support.expanded {\n  padding: var(--sidebar-padding, 12px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebar-item": `V68YTM`,
	"sidebarItem": `V68YTM`,
	"sidebar-item-selected": `IwJf_e`,
	"sidebarItemSelected": `IwJf_e`,
	"sidebar-overlay": `XMalAY`,
	"sidebarOverlay": `XMalAY`,
	"active": `V0xZ97`,
	"sidebar-mobile": `Lk9s99`,
	"sidebarMobile": `Lk9s99`,
	"closing": `JUylJP`,
	"sidebar-mobile-header": `g9eVvt`,
	"sidebarMobileHeader": `g9eVvt`,
	"sidebar-mobile-content": `HJoRqN`,
	"sidebarMobileContent": `HJoRqN`,
	"sidebar-mobile-support": `aklxO5`,
	"sidebarMobileSupport": `aklxO5`,
	"sidebar-desktop-header": `svQapB`,
	"sidebarDesktopHeader": `svQapB`,
	"collapsed": `crg3Xs`,
	"expanded": `m8TOKQ`,
	"sidebar-toggle-button": `gvZ_C1`,
	"sidebarToggleButton": `gvZ_C1`,
	"sidebar-desktop": `fa43HX`,
	"sidebarDesktop": `fa43HX`,
	"sidebar-header": `AOTUtj`,
	"sidebarHeader": `AOTUtj`,
	"sidebar-collapse-button-container": `ThLNU3`,
	"sidebarCollapseButtonContainer": `ThLNU3`,
	"sidebar-collapse-button": `IbvAg8`,
	"sidebarCollapseButton": `IbvAg8`,
	"sidebar-logo-container": `Me12AO`,
	"sidebarLogoContainer": `Me12AO`,
	"sidebar-logo": `tXTRwf`,
	"sidebarLogo": `tXTRwf`,
	"sidebar-logo-image": `tZpZRK`,
	"sidebarLogoImage": `tZpZRK`,
	"sidebar-title": `NO26Zj`,
	"sidebarTitle": `NO26Zj`,
	"sidebar-content": `pHfXNQ`,
	"sidebarContent": `pHfXNQ`,
	"sidebar-support": `y5n0am`,
	"sidebarSupport": `y5n0am`
};
module.exports = ___CSS_LOADER_EXPORT___;
